// Faceted Search Entry Point
import '../styles/pages/_faceted-search.scss';
import './pages/facetedSearchFilters.js';
